// extracted by mini-css-extract-plugin
export default {"avatar":"irETv___Avatar-module__avatar"};